import React from "react";
import ThinkingDetailBgLanding from "./ThinkingDetailBgLanding";
import { Box } from "@mui/material";
import ThinkingDetailContent from "./ThinkingDetailContent";
import { Helmet } from "react-helmet";

const ThinkingDetailPage = () => {
  return (
    <>
      <Helmet>
        <title>Inteliphyle | AI and the CEO</title>
        <meta
          name="description"
          content="The relevance of the title is high because AI appears to be the ultimate enabler of the corporate world, and the CEO is the ultimate decision-maker of that world."
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#ecebeb",
        }}
      >
        <ThinkingDetailBgLanding />
        <ThinkingDetailContent />
      </Box>
    </>
  );
};

export default ThinkingDetailPage;
